import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=6ac5c788&scoped=true"
import script from "./resume.vue?vue&type=script&lang=js"
export * from "./resume.vue?vue&type=script&lang=js"
import style0 from "./resume.vue?vue&type=style&index=0&id=6ac5c788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5c788",
  null
  
)

export default component.exports